import { membershipCollection } from 'app/src/msw/membership/initialSeed/membership'
import { refundCollection } from 'app/src/msw/refund/initialSeed/refund'
import { createDocumentRefund } from 'app/src/msw/refund/utils/refundUtils'
import { creditCollection } from 'app/src/msw/shopping/initialSeed/credit'
import { refundsOrdersCollection } from 'app/src/msw/shopping/initialSeed/orders'
import { updateCredit } from 'app/src/msw/shopping/utils/updateCredit'
import type { refundApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './refund/api/v1'

export const confirmRefund = http.post<
  refundApi.RefundRequestConfirmPathParams,
  refundApi.RefundConfirmRequest,
  refundApi.RefundConfirmResponse
>(apiBaseUrl + '/refunds/:refundId/confirm', async ({ request, params }) => {
  console.log('########## MSW: START CONFIRM REFUND ##########')

  await new Promise((resolve) => setTimeout(resolve, 3000))

  const body = await request.json()

  const activeMembership = JSON.parse(sessionStorage.getItem('selectedCampaign') || '{}')

  /* Preparing datas for refund */
  const membershipData = await membershipCollection.findFirst()
  console.log('STEP 1 => check membership: ', membershipData ? 'OK' : 'KO')
  const refund = await refundCollection.findFirst((q) => q.where({ refundId: params.refundId }))
  console.log('STEP 2 => check refund: ', refund ? 'OK' : 'KO')
  const refundOrder = await refundsOrdersCollection.findFirst((q) => q.where({ orderId: refund?.attributes?.orderId }))
  console.log('STEP 3 => check refund order: ', refundOrder ? 'OK' : 'KO')
  const credit = await creditCollection.findFirst((q) => q.where({ membershipId: activeMembership?.membershipId }))
  console.log('STEP 4 => check credit: ', credit ? 'OK' : 'KO')

  /* creating invoice document */
  const updatedInvoice = createDocumentRefund(membershipData!, body, params?.refundId as string)

  if (refundOrder && refund && credit) {
    /* preparing price details */
    const priceDetails = {
      grossPrice: updatedInvoice?.data?.invoiceTotal?.value || 0,
      netPrice: (updatedInvoice?.data?.invoiceTotal?.value || 0) - (updatedInvoice?.data?.totalTax?.value || 0),
      taxPercentage: 0.24,
      taxAmount: updatedInvoice?.data?.totalTax?.value || 0,
    }
    /* check sufficient credit */
    if (!refundOrder.product?.serviceCategory) {
      console.error('Refund order is missing service category')
      console.log('########## MSW: END CONFIRM REFUND ##########')
      return HttpResponse.json({ status: { value: 'CANCELED' } })
    }
    if (credit.creditByServiceCategory[refundOrder.product.serviceCategory] === undefined) {
      console.error('Credit is missing service category entry for', refundOrder.product.serviceCategory)
      console.log('########## MSW: END CONFIRM REFUND ##########')
      return HttpResponse.json({ status: { value: 'CANCELED' } })
    }
    if ((credit.creditByServiceCategory[refundOrder.product.serviceCategory]?.available || 0) < priceDetails.grossPrice) {
      console.error('Insufficient credit for service category', refundOrder.product.serviceCategory)
      console.log('########## MSW: END CONFIRM REFUND ##########')
      return HttpResponse.json({ status: { value: 'CANCELED' } })
    }

    /* update order status */
    const updatedOrder = await refundsOrdersCollection.update(refundOrder, {
      data(order) {
        order.status = 'confirmed' // TODO
        order.priceDetails = priceDetails
      },
    })
    /* update refund status */
    await refundCollection.update((q) => q.where({ refundId: params?.refundId as string }), {
      data(refund) {
        refund.status.value = 'REFUNDED'
        refund.status.updatedAt = new Date().toISOString()
        refund.requestedTotal = body.requestedTotal
        refund.isCancelable = false
        refund.invoice = updatedInvoice
      },
    })

    try {
      await updateCredit(updatedOrder || refundOrder)
    } catch (error) {
      console.error('Error starting order:', error)
      return HttpResponse.json({ status: { value: 'FAILED' } }, { status: 409 })
    }
  } else {
    console.error('Error processing refund confirmation: missing data')
    console.log('########## MSW: END CONFIRM REFUND ##########')
    return HttpResponse.json({ status: { value: 'CANCELED' } })
  }

  console.log('########## MSW: END CONFIRM REFUND ##########')

  return HttpResponse.json({ status: { value: 'SUBMITTED' } })
})
